import React, { useCallback, useMemo } from "react"
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  useTheme,
  Button,
  CardProps,
} from "@mui/material"
import { getIcon } from "utils/icon"
import { PostData } from "providers/venue/types"
import { deepmerge } from "@mui/utils"
import { useTranslation } from "providers/i18n"
import { Link } from "react-router-dom"
import { getPostDetail, IPostDetail } from "utils/feature"
import { ImdfFeature } from "providers/venue/types"
import { pushDataLayer } from "utils/googletagmanager"
import { GTM_VIEW_POST } from "constant"
import { get } from "lodash"

export interface IAttractionCardProps extends CardProps {
  data: PostData
}

export const AttractionCard: React.FC<IAttractionCardProps> = ({
  data,
  sx = {},
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { styleOverrides = {} } = theme.components?.[`AttractionCard`] || {}
  const { root, cardMedia, cardContent, descriptionText, button, titleText } =
    styleOverrides

  const { locationUrl, coverImage, title, description, type, category, id } =
    getPostDetail(data as unknown as ImdfFeature) as IPostDetail
  const icon = useMemo(
    () => getIcon(theme?.assets?.attractionCardIcon),
    [theme]
  )

  const handleClick = useCallback(() => {
    pushDataLayer({
      event: GTM_VIEW_POST,
      post_type: type,
      post_category: get(category, "en"),
      post_id: id,
      post_title: get(title, "en"),
    })
  }, [type, id, title, category])

  const isRtl = theme.isRtl

  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <CardMedia sx={cardMedia} image={coverImage} />
      <CardContent sx={cardContent}>
        <Typography variant="h5" component="div" sx={titleText}>
          {t(title)}
        </Typography>
        <Typography variant="body2" sx={descriptionText}>
          {t(description)}
        </Typography>
      </CardContent>
      {locationUrl && (
        <Button
          component={Link}
          sx={button}
          to={locationUrl}
          className={isRtl ? "is-rtl" : ""}
          onClick={handleClick}
        >
          {icon}
        </Button>
      )}
    </Card>
  )
}
